import React from "react";
import inmoLogo from "../../assets/images/inmoLogo.png";
import profileIconW from "../../assets/images/interface/person-circle-outline-white.svg";
import InputSearch from "../InputSearch";

const HomeMobile = () => {
  return (
    <>

      <div className="home-column home-column-left home-mobile">
        <div>
          <img
            className="home-inmo-logo"
            src={inmoLogo}
            alt="inmo loteamientos"
          ></img>

          <InputSearch className="home-input desktop-noDisplay" mode={"input"} />
        </div>
      </div>
    </>
  )
}

export default HomeMobile;
